<template>
    <div
      class="loader"
      :style="customStyle"
    ></div>
  </template>
  
  <script>
  export default {
    name: "OLoadingSmall",
    props: {
      width: {
        type: String,
        default: "15px"
      },
      height: {
        type: String,
        default: "15px"
      },
      border: {
        type: String,
        default: "3px solid var(--primary-color, #f27178)"
      },
      borderTopColor: {
        type: String,
        default: "transparent"
      }
    },
    computed: {
      customStyle() {
        return {
          width: this.width,
          height: this.height,
          border: this.border,
          borderTopColor: this.borderTopColor,
          borderRadius: "50%",
        };
      }
    }
  };
  </script>
  
  <style scoped>
    .loader {
      /* fallback styles if not overridden by props */
      width: 15px;
      height: 15px;
      border-radius: 50%;
      border: 3px solid var(--primary-color, #f27178);
      border-top-color: transparent;
      animation: rot1 1.2s linear infinite;
    }
  
    @keyframes rot1 {
      to {
        transform: rotate(360deg);
      }
    }
  </style>